import { NewsMixpanelEvents } from '../../constants/mixpanel-events';
import type { ArticleReadSection } from '../trackArticleRead/trackArticleRead';
import type { ReadTimeMilestone } from '$global/utils/createActiveReadTimer/createActiveReadTimer';
import { track } from '$global/utils/track';

// Read-time milestone event (HB-977). One event per milestone crossed; the
// read-time band is derived downstream from the highest milestone reached, so
// no band is computed here. Article metadata beyond the id is joined downstream
// via article_id, matching trackArticleRead.
export const trackArticleReadTime = ({
	articleId,
	section,
	milestone,
}: {
	articleId: string;
	section: ArticleReadSection;
	milestone: ReadTimeMilestone;
}) => {
	track(NewsMixpanelEvents.ArticleReadTime, {
		article_id: articleId,
		section,
		milestone,
	});
};
